// window.helper = helper;
let reviewsCountElm, reviewsCount, reviewsCountArray;
let spaceY = window.innerHeight / 2;
let body = document.body;

if (document.getElementById('reviews-count') != undefined) {
  reviewsCountElm = document.getElementById('reviews-count');
  reviewsCount = reviewsCountElm.dataset.reviewsCount;
  reviewsCountArray = reviewsCount.split('');
}

class AnimateBgColorOpacity extends HTMLElement {
  constructor() {
    super();
    this.rgb = this.dataset.animBgColor;
    this.fromRgb;
    if (this.dataset.animFromBgColor != undefined) {
      this.fromRgb = this.dataset.animFromBgColor;
      this.closest('section').style.backgroundColor = this.fromRgb;
    }
    this.rgbArray = rgbToArray(this.rgb);
    this.mainSection = this.querySelector('.anim-background-opacity-effect');
    this.onScroll();
  }

  onScroll() {
    document.addEventListener('scroll', () => {
      let sectionScrollY = this.mainSection.offsetTop;
      let sectionStartPosition = sectionScrollY - spaceY;
      let sectionHeight = this.mainSection.clientHeight;
      let sectionEndPosition = sectionScrollY + sectionHeight + spaceY;
      if (isActiveArea(sectionStartPosition, sectionEndPosition) == true) {
        this.changeOpacity(
          this.mainSection,
          sectionStartPosition,
          sectionEndPosition,
          this.rgbArray
        );
      } else {
        if (body.style.removeProperty) {
          body.style.removeProperty('background-color');
        } else {
          body.style.removeAttribute('background-color');
        }
      }
    });
  }

  changeOpacity(section, startPosition, endPosition, rgbArray) {
    let midPosition = (startPosition + endPosition) / 2;
    let opacity =
      (window.scrollY - startPosition) / (startPosition / midPosition) / 100;
    let reverseOpacity =
      1 - (window.scrollY - midPosition) / (endPosition - midPosition - spaceY);
    if (window.scrollY >= startPosition) {
      if (opacity < 0.1) {
        opacity += 0.1;
      }
      body.style.backgroundColor = `rgb(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]}, ${opacity})`;
    }
    if (window.scrollY > midPosition) {
      body.style.backgroundColor = `rgb(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]}, ${reverseOpacity})`;
    }
  }
}

customElements.define('animate-bg-color-opacity', AnimateBgColorOpacity);

const oddItems = document.querySelectorAll('.testimonial__wrap.odd__item');
const evenItems = document.querySelectorAll('.testimonial__wrap.even__item');
let wrapper = document.querySelector('.section-testimonial');
let countTimes = 0;

class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.testimonial__list');
    this.sliderItems = this.slider.querySelectorAll('.testimonial__wrap');
    if (window.innerWidth > 750) {
      this.onMouseDrag(this.slider, this.sliderItems);
    }
    this.onScrollAnimation();
  }

  onMouseDrag(element, childrenElms) {
    if (element.dataset.draggable == 'true') {
      let xMouseDown;
      let xMouseUp;
      element.addEventListener('mousedown', (e) => {
        if (element.contains(e.target)) {
          xMouseDown = e.pageX;
        }
      });
      element.addEventListener('mouseup', (e) => {
        if (element.contains(e.target)) {
          xMouseUp = e.pageX;
        }
        let itemFirst = childrenElms[0];
        let itemLast = childrenElms[childrenElms.length - 1];
        let itemFirstPosition = itemFirst.getBoundingClientRect().x;
        let itemLastPosition = itemLast.getBoundingClientRect().x;
        childrenElms.forEach((elm) => {
          let matrix = new WebKitCSSMatrix(elm.style.transform);
          let initialPosition = matrix.m41;
          this.mouseDragDirection(
            elm,
            xMouseDown,
            xMouseUp,
            initialPosition,
            itemFirstPosition,
            itemLastPosition
          );
        });
      });
    }
  }

  mouseDragDirection(
    element,
    x,
    y,
    initialPosition,
    leftPosition,
    rightPosition
  ) {
    let maxLeft = 0;
    let maxRight = window.innerWidth - element.clientWidth;
    if (x > y) {
      if (rightPosition > maxRight) {
        let translateXValue = initialPosition - element.clientWidth;
        element.style.transform = `translateX(${translateXValue}px)`;
      }
    } else if (x < y) {
      if (leftPosition < maxLeft) {
        let translateXValue = initialPosition + element.clientWidth;
        element.style.transform = `translateX(${translateXValue}px)`;
      }
    } else {
      return;
    }
  }

  onScrollAnimation() {
    document.addEventListener('scroll', () => {
      if (
        isActiveArea(
          this.offsetTop - 500,
          this.offsetTop + wrapper.clientHeight
        ) == true
      ) {
        let maxLeft = 50;
        let maxRight = window.innerWidth - this.sliderItems[0].clientWidth;
        if (scrollDirection() == 'up') {
          let itemFirstPosition = this.sliderItems[0].getBoundingClientRect().x;
          if (itemFirstPosition < maxLeft) {
            this.sliderItems?.forEach((item) => {
              let matrix = new WebKitCSSMatrix(item.style.transform);
              let initialPosition = matrix.m41;
              let translateXValue = initialPosition + 4;
              item.style.transform = `translateX(${translateXValue}px)`;
            });
          }
        } else {
          let itemLastPosition =
            this.sliderItems[
              this.sliderItems.length - 1
            ].getBoundingClientRect().x;
          if (itemLastPosition > maxRight) {
            this.sliderItems?.forEach((item) => {
              let matrix = new WebKitCSSMatrix(item.style.transform);
              let initialPosition = matrix.m41;
              let translateXValue = initialPosition - 4;
              item.style.transform = `translateX(${translateXValue}px)`;
            });
          }
        }
      }

      if (
        reviewsCountElm.getBoundingClientRect().top <
        document.documentElement.offsetHeight - 200
      ) {
        if (countTimes < 1) {
          countTimes += 1;
          rangeCounter(
            reviewsCountElm,
            0,
            reviewsCount,
            reviewsCount / 50,
            4000
          );
        }
      }
    });
  }
}

customElements.define('testimonial-slider', TestimonialSlider);

class AnimateImageItems extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.imagelist-with-text__wrapper');
    this.wrapperHeight = this.querySelector(
      '.imagelist-with-text__wrapper'
    ).offsetHeight;
    this.images = this.querySelectorAll('.img__item');
    this.imagesDown = this.querySelectorAll(
      '.img__item[data-translate-direction="down"]'
    );
    this.imagesUp = this.querySelectorAll(
      '.img__item[data-translate-direction="up"]'
    );

    document.addEventListener('scroll', () => {
      this.translateY();
    });
  }

  translateY() {
    if (
      isActiveArea(
        this.wrapper.offsetTop,
        this.wrapper.offsetTop + this.wrapper.clientHeight
      ) == true
    ) {
      if (scrollDirection() == 'down') {
        this.imagesDown.forEach((image) => {
          image.style.transition = 'top 3s linear';
          let imageHeightPercentage = image.offsetHeight / this.wrapperHeight;
          let top = (1 - imageHeightPercentage + getRandomFloat(0.1, 0.2)) * 80;
          image.style.top = `${top}%`;
        });

        this.imagesUp.forEach((image) => {
          image.style.transition = 'top 3s linear';
          let top = image.dataset.originalTop - getRandomFloat(20, 30);
          image.style.top = `${top}%`;
        });
      } else {
        this.imagesUp.forEach((image) => {
          image.style.transition = 'top 3s linear';
          image.style.top = `${image.dataset.originalTop}%`;
        });

        this.imagesDown.forEach((image) => {
          image.style.transition = 'top 3s linear';
          image.style.top = `${image.dataset.originalTop}%`;
        });
      }
    } else {
      return;
    }
  }
}

customElements.define('animate-image-items', AnimateImageItems);

if (typeof AOS != 'undefined') {
  const aosMobileEnabled = document.body.dataset.aosMobile !== 'false';
  const isMobile = window.matchMedia('(max-width: 750px)').matches;

  if (!isMobile || aosMobileEnabled) {
    AOS.init({
      once: true,
    });
  }
}
